import Card from '@/components/elements/Card/Card';
import { classnames } from '@/helpers';

const skeletonGradient = 'bg-surface_l4 animate-pulse';

export const InstagramFeedSkeleton = ({
  withCard,
  withInstagramIcon,
  slides = 3,
}: {
  withCard?: boolean;
  withInstagramIcon?: boolean;
  slides?: number;
}) => {
  const content = (
    <div aria-hidden="true" className={`flex flex-col ${withCard ? 'gap-xl' : ''}`}>
      <div className="gap-xs mb-4 flex w-full items-center">
        {withInstagramIcon && <div className={classnames(skeletonGradient, 'h-6 w-6 shrink-0 rounded-sm')} />}
        <div className={classnames(skeletonGradient, 'h-lg w-[100px] rounded')} />
        <div className={classnames(skeletonGradient, 'h-md ml-auto w-[90px] rounded')} />
      </div>

      <div className="relative overflow-hidden">
        <div className="bg-bg_secondary_bold absolute left-2 top-1/2 z-10 h-10 w-10 -translate-y-1/2 rounded-full" />

        <div className="-mr-2 flex">
          {Array.from({ length: slides }, (_, key) => key).map((key) => (
            <div
              key={key}
              className={classnames(skeletonGradient, 'mr-2 aspect-square w-full flex-shrink-0 rounded-md')}
              style={{ width: `calc(${100 / slides}% - 8px)` }}
            />
          ))}
        </div>

        <div className="bg-bg_secondary_bold absolute right-2 top-1/2 z-10 h-10 w-10 -translate-y-1/2 rounded-full" />
      </div>
    </div>
  );

  return withCard ? <Card size={'lg'}>{content}</Card> : content;
};

export default InstagramFeedSkeleton;
